import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {httpClient} from "../../funcs";
import SelectOptionsView from './SelectOptionsView';

const LIMIT = 15;

let SelectTemplateView: any = function SelectTemplateView(props: any) {
    const includePdf = Boolean(props.includePdf)
    const [templates, setTemplates] = useState<any[]>([])
    const [offset, setOffset] = useState(0)
    const [hasMore, setHasMore] = useState(true)
    const [loading, setLoading] = useState(false)

    useEffect(
        () => {
            setOffset(0)
            setHasMore(true)
            loadTemplate(0, true)
        },
        [includePdf]
    )

    async function loadTemplate(currentOffset: number, reset: boolean = false) {
        if (!reset && loading) return;
        
        setLoading(true)
        try {
            const {data} = await httpClient.get(`/templates`, {
                params: {
                    limit: LIMIT,
                    offset: currentOffset,
                    ...(includePdf ? { include_pdf: 'true' } : {}),
                }
            })
            
            if (reset) {
                setTemplates(data)
            } else {
                setTemplates(prev => [...prev, ...data])
            }
            
            // Если получили меньше чем лимит, значит больше нет данных
            setHasMore(data.length === LIMIT)
            setOffset(currentOffset + data.length)
        } catch (error) {
            console.error('Ошибка загрузки шаблонов:', error)
        } finally {
            setLoading(false)
        }
    }

    async function loadMore() {
        if (hasMore && !loading) {
            await loadTemplate(offset, false)
        }
    }

    const loadedOptions = templates.map((template) => {
        const title =
            template.body_type === 'pdf'
                ? 'PDF'
                : template.name + '. ' + (template.comment ?? '')
        return {
            id: template._id,
            title,
        }
    })

    // Если переданы кастомные опции, используем их, иначе загружаем шаблоны
    const options = props.options !== undefined
        ? props.options
        : [...(props.prependOptions ?? []), ...loadedOptions]

    return (
        <SelectOptionsView
            selectedOption={props.selectedTemplate}
            onSelectOption={props.didSelectTemplate}
            options={options}
            placeholder={props.placeholder || "Выберите шаблон"}
            height={props.height}
            width={props.width ?? 'full'}
            freeSolo={props.freeSolo ?? false}
            popperZIndex={props.popperZIndex}
            onLoadMore={props.options === undefined ? loadMore : undefined}
            hasMore={props.options === undefined ? hasMore : false}
            loading={loading}
        />
    )
}

SelectTemplateView = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(SelectTemplateView)

export default SelectTemplateView
